// File: whatsapp.service-profile-ops.js
import { axiosInstance, DEFAULT_SESSION } from './whatsapp.service-config';
import { ERROR_MESSAGES } from './whatsapp.service-errors';
import { _handleError } from './whatsapp.service-utils'; // No formatChatId needed here directly

export const getProfilePicture = async (phoneNumber) => {
  try {
    const chatId = `${phoneNumber}@c.us`; // Direct formatting as per original
    console.log(`[WhatsApp Profile Ops] Fetching profile picture for: ${phoneNumber}`);
    const response = await axiosInstance.get(`${DEFAULT_SESSION}/chats/${chatId}/picture`);
    console.log('[WhatsApp Profile Ops] Profile picture response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[WhatsApp Profile Ops] Profile picture error:', error);
    console.error('[WhatsApp Profile Ops] Error response:', error.response?.data);
    const errorMessage = _handleError(error, ERROR_MESSAGES.PROFILE_FETCH_FAILED);
    console.error(`[WhatsApp Profile Ops] Profile picture fetch failed: ${errorMessage}`);
    throw new Error(errorMessage);
  }
};

export const getContactName = async (phoneNumber) => {
  try {
    const chatId = `${phoneNumber}@c.us`; // Direct formatting as per original
    console.log(`[WhatsApp Profile Ops] Fetching contact name for: ${phoneNumber}`);
    const response = await axiosInstance.get(`${DEFAULT_SESSION}/contacts/${chatId}`);
    console.log('[WhatsApp Profile Ops] Contact name response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[WhatsApp Profile Ops] Contact name error:', error);
    console.error('[WhatsApp Profile Ops] Error response:', error.response?.data);
    const errorMessage = _handleError(error, ERROR_MESSAGES.PROFILE_FETCH_FAILED);
    console.error(`[WhatsApp Profile Ops] Contact name fetch failed: ${errorMessage}`);
    throw new Error(errorMessage);
  }
};